import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class CommonValidation {

    getValidation(invalidData) {
        let validateArray = [];
        let fields = this.validationList();
        invalidData.forEach(element => {
            let fieldValue = fields.filter(x => x.id == element);
            fieldValue.forEach(element => {
                validateArray.push(element.value);
            });
        });
        return validateArray;
    }

    validationList() {
        let requiredFields = [];
        requiredFields = [
            { id: 'meetingTitle', value: 'Title' },
            { id: 'clientName', value: 'Client Name' },
            { id: 'projectName', value: 'Project Name' },
            { id: 'projectType', value: 'Billing Type' },
            { id: 'currentStatus', value: 'Project Status' },
            { id: 'projectStartDate', value: 'Project Start Date' },
            { id: 'actualCompletionDate', value: 'Actual Completion Date' },
            { id: 'extendedCompletionDate', value: 'Extended Completion Date' },
            { id: 'projectDescription', value: 'Project Description' },
            { id: 'projectPlatform', value: 'Project Platform' },
            { id: 'Resources', value: 'Resources' },
            { id: 'Role', value: 'Role' },
            { id: 'No Of Resources', value: 'No Of Resources' },
            { id: 'Hours', value: 'Hours' },
            { id: 'addOnType', value: 'AddOn' },
            { id: 'startDate', value: 'Start Date' },
            { id: 'endDate', value: 'End Date' },
            { id: 'reason', value: 'Reason' },
            { id: 'leaveType', value: 'Leave Type' },
            { id: 'appliedDate', value: 'Applied Date' },
            { id: 'backToWorkDate', value: 'Back To Work Date' },
            { id: 'totalDays', value: 'Total Days' },
            { id: 'startTime', value: 'Start Time' },
            { id: 'endTime', value: 'End Time' },
            { id: 'description', value: 'Description' },
            { id: 'title', value: 'Title' },
            { id: 'notes', value: 'Notes' },
            { id: 'sessionType', value: 'Session Type' },

            { id: 'jobTitle', value: 'Job Title' },
            { id: 'date', value: 'Date' },
            { id: 'department', value: 'Department' },
            { id: 'manager', value: 'Manager' },
            { id: 'reviewStartDate', value: 'Review Start Date' },
            { id: 'reviewEndDate', value: 'Review End Date' },
            { id: 'additionalComments', value: 'Additional Comments' },
            { id: 'goals', value: 'Goals' },
            { id: 'jobKnowledge', value: 'Job Knowledge' },
            { id: 'workQuality', value: 'Work Quality' },
            { id: 'initiative', value: 'Initiative' },
            { id: 'communication', value: 'Communication' },
            { id: 'dependability', value: 'Dependability' },
            { id: 'selectResource', value: 'Select Resource' },
            { id: 'incorrectSessionType', value: 'Incorrect Session Type'}
        ];

        return requiredFields;
    }


}